const translations = {
  "en": {
    "HK Market": "HK Market",
    "US Market": "US Market"
  },
  "zh-tw": {
    "HK Market": "香港市場",
    "US Market": "美國市場"
  }
};

export default translations;
